<template>
    <div id="app">
        <div v-if="isAuthenticated">
            <AppHeader style="top: 0;z-index: 999;position:fixed; width: 100%;"/>
            <main class="app-main" style="margin-top: 40px">
                <div class="container is-fluid">
                    <div class="columns">
                        <div class="column" style="width: 100%">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view class="view"></router-view>
                                </transition>
                            </keep-alive>
                        </div>
                    </div>
                </div>
            </main>
            <AppFooter/>
        </div>
        <div v-else>
            <Login/>
        </div>
        <notifications class="vue-notification-custom" :duration="10000"  style="font-size: 24px; font-family: Consolas;font-weight: bolder ;margin-top: 65px;min-width: 600px;margin-right: 38%;"/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    import AppHeader from "./components/layout/AppHeader";
    import AppFooter from "./components/layout/AppFooter";
    import Login from "./pages/Auth/Login";

    export default {
        created() {
            //console.log(this.isAuthenticated)
        },
        components: {
            AppFooter,
            AppHeader,
            Login
        },
        computed: {
            ...mapGetters("auth", ["isAuthenticated"])
        },

    }
</script>
<style lang="scss">

    .vue-notification-custom
    {
        font-size: 18px;

    }

    html{
        zoom:0.8;
    }
    .app-main {
        padding: 3rem;
    }

    .table td {
        border: 0px;
    }

    .vue-notification-group {
        top: 25px;
        right: 25px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .15s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>

